var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mic_container"},[_c('div',[_c('iframe',{staticStyle:{"position":"fixed","top":"0","left":"0","bottom":"0","right":"0","width":"100%","height":"100%","border":"none","margin":"75px 0px","padding":"0","overflow":"hidden"},attrs:{"src":_vm.quizPage,"frameborder":"0"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fca6b04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/quiz/QuizPage.vue
// module id = null
// module chunks = 